import InscriptionFormFieldModalView from "./inscriptionFormFieldModal.html";


angular.module("inscriptions_forms")

    .controller("InscriptionsFormsEditCtrl", ['event', 'is_template', 'LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', '$http', 'logService',
        function (event, is_template, LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, $http, logService) {

            $scope.inscription_form = {
                FK_inscriptions_forms_fields_inscriptions_forms: [],
                FK_inscriptions_forms_images: {},
                event_id: event != null ? event.id : null,
                inscription_form_id: $stateParams.inscription_form_id,
                is_template: is_template
            };

            let color = (window as any).CONFIG_TINYMCE["no_company_id"].color;
            let font_size = (window as any).CONFIG_TINYMCE["no_company_id"].font_size;
            let font_family = (window as any).CONFIG_TINYMCE["no_company_id"].font_family;

            if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")]) !== 'undefined') {

                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_color_description) !== 'undefined') {
                    color = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_color_description;
                }
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size) !== 'undefined') {
                    font_size = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size;
                }
                if (typeof ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family) !== 'undefined') {
                    font_family = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family;
                }

            }

            // Cargamos la inscripción si toca
            if (angular.isDefined($stateParams.inscription_form_id) && $stateParams.inscription_form_id != "") {

                Restangular.one('InscriptionsForms', $stateParams.inscription_form_id).get().then(function (results) {

                    $scope.inscription_form = results;

                    // Seleccionamos los emails
                    $scope.inscription_form.send_email_confirmation = false;
                    $scope.inscription_form.send_email_enrolled = false;
                    $scope.inscription_form.send_email_rejected = false;

                    if ($scope.inscription_form.email_confirmation !== "" && $scope.inscription_form.email_confirmation !== null) $scope.inscription_form.send_email_confirmation = true;
                    if ($scope.inscription_form.email_enrolled !== "" && $scope.inscription_form.email_enrolled !== null) $scope.inscription_form.send_email_enrolled = true;
                    if ($scope.inscription_form.email_rejected !== "" && $scope.inscription_form.email_rejected !== null) $scope.inscription_form.send_email_rejected = true;

                    $scope.inscription_form.event_date_init = $scope.inscription_form.event_date_init === null ? null: new Date(results.event_date_init);
                    $scope.inscription_form.event_date_end = $scope.inscription_form.event_date_end === null ? null: new Date(results.event_date_end);

                });

            }

            if (!is_template) {
                // Info evento.
                $scope.is_template = false;
                $rootScope.title = event.name;
                $rootScope.title = event.name + " - " + $filter('translate')('inscriptions_forms.title');

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: event.name, url: "events.edit({ id: " + event.id + " })" },
                    { title: $filter('translate')('inscriptions_forms.title'), url: "events.edit.inscriptions_forms({ event: " + $stateParams.id + " })" },
                ];

            } else {
                $scope.is_template = true;
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('inscriptions_forms.title') }
                ];
            }

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("INSCRIPTIONS_FORMS_WRITE");
            

            Restangular.all('Languages').getList({ use_for_events: true }).then(function (languages) {

                $scope.languages = languages;

            });

            $scope.gridInscriptionsFormsFields = {
                pdfTitle: $filter('translate')('inscriptions_forms.fields'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                enablePagination: true,
                autoHeight : true,
                rowTemplate: '<div ng-dblclick="grid.appScope.addInscriptionFormField(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'order', width: 40, displayName: $filter('translate')('inscriptions_forms.order'), enableFiltering: false, enableHiding: false },
                    { name: 'size', width: 80, displayName: $filter('translate')('inscriptions_forms.size'), enableFiltering: false, enableHiding: true },
                    { name: 'name', displayName: $filter('translate')('inscriptions_forms.name'), enableFiltering: true, enableHiding: false },
                    { name: 'FK_inscriptions_forms_fields_types_fields.description', displayName: $filter('translate')('inscriptions_forms.type_field'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('inscriptions_forms.button_edit'), action: 'ng-click="grid.appScope.addInscriptionFormField(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('inscriptions_forms.button_delete'), action: 'ng-click="grid.appScope.deleteInscriptionFormField(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    }
                ],
                getData: function (options) {

                    let deferred = $q.defer();

                    if (angular.isDefined($stateParams.inscription_form_id) && $stateParams.inscription_form_id != "") {

                        options.inscription_form_id = $stateParams.inscription_form_id;

                       Restangular.all('InscriptionsFormsFields').getList(options).then(function (results) {

                            logService.debug(results)

                            results.forEach(field => field.size = getInscriptionFieldSize(field));
                            deferred.resolve(results);

                       });

                    }

                    return deferred.promise;

                }
            };

            $scope.tinymceMailOptions = {

                resize: true,
                contextmenu: false,
                branding: false,
                schema: "html5",
                relative_urls: false,
                remove_script_host: true,

                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
                },

                invalid_elements: 'strong,em',
                fontsize_formats: "12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px 40px 44px 48px",
                font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
                body_class: 'custom_tinymce_content',
                forced_root_block: 'p',
                content_style: "p {  }",
                language: $translate.use().toLowerCase(), // Hay que customizarlo dependiendo del idioma...
                // language_url: "Scripts/tinymce/langs/es.js",
                plugins: 'textcolor paste',
                toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor fontselect | alignleft aligncenter alignright alignjustify",
                menubar: false,
                forced_root_block_attrs: {

                    'style': 'font-family: ' + font_family + '; font-size: ' + font_size + ';  line-height: 1.2; margin-top: 0; margin-bottom: 0;'

                }

            }; 

            $scope.tinymceTitleOptions = {

                ...$scope.tinymceMailOptions,
                setup: function (editor) {
                    editor.on('init', function () {
                        editor.execCommand('FontSize', false, '36px');
                    });
                    // Limitar escritura
                    editor.on('beforeinput', function (e) {
                        let plainText = editor.getContent({ format: 'text' });
                        if (plainText.length >= 250 && e.inputType !== 'deleteContentBackward') {
                            e.preventDefault();
                        }
                    });
                    // Limitar pegado
                    editor.on('paste', function (e) {
                        let clipboardData = e.clipboardData;
                        let pastedText = clipboardData ? clipboardData.getData('Text') : '';
                        let plainText = editor.getContent({ format: 'text' });
                        let availableText = 250 - plainText.length;

                        // Solo dejamos pegar hasta donde se pueda
                        e.preventDefault();
                        if (availableText > 0) editor.insertContent(pastedText.substring(0, availableText));

                    });
                }
            }

            $scope.tinymceDescriptionOptions = {

                ...$scope.tinymceMailOptions,
                setup: function (editor) {
                    editor.on('init', function () {
                        editor.execCommand('FontSize', false, '24px');
                    });
                    // Limitar escritura
                    editor.on('beforeinput', function (e) {
                        let plainText = editor.getContent({ format: 'text' });
                        if (plainText.length >= 500 && e.inputType !== 'deleteContentBackward') {
                            e.preventDefault();
                        }
                    });
                    // Limitar pegado
                    editor.on('paste', function (e) {
                        let clipboardData = e.clipboardData;
                        let pastedText = clipboardData ? clipboardData.getData('Text') : '';
                        let plainText = editor.getContent({ format: 'text' });
                        let availableText = 500 - plainText.length;

                        // Solo dejamos pegar hasta donde se pueda
                        e.preventDefault();
                        if (availableText > 0) editor.insertContent(pastedText.substring(0, availableText));

                    });
                }
            }

            $scope.save = function (frmInscriptionForm) {
                if ($scope.inscription_form.inscription_form_id === "") {
                    delete $scope.inscription_form["inscription_form_id"];
                }
                if (angular.isDefined($scope.inscription_form.id)) {
                    $scope.inscription_form.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('inscriptions_forms.edit_success'));
                            $scope.gridInscriptionsFormsFields.loadData(false);
                        }
                    });
                } else {
                    Restangular.all('InscriptionsForms').post($scope.inscription_form).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('inscriptions_forms.create_success'));
                            if ($scope.inscription_form.is_template) {
                                $state.go("inscriptions_forms.edit", { inscription_form_id: result.id });
                            } else {
                                $state.go("events.edit.inscriptions_forms.edit", { inscription_form_id: result.id });
                            }                            
                        }
                    });
                }

            };

            $scope.checkDelete = function () {
                    modalService.confirm({
                    title: $filter('translate')('inscriptions_forms.button_delete'),
                        message: $filter('translate')('inscriptions_forms.delete_message') + " " + $scope.inscription_form.event_name + "?",
                    onAccept: function () {
                        $scope.inscription_form.remove().then(function () {
                            toastr.success($filter('translate')('inscriptions_forms.delete_success'));
                            if (is_template) {
                                $state.go("inscriptions_forms.list", { is_template: is_template });
                            } else {
                                $state.go("events.edit.inscriptions_forms", { event: $stateParams.id });
                            }
                            
                        });
                    }
                });
            };

            $scope.openUrl = function (uid) {
                Restangular.all("InscriptionsForms").customGET("CustomGetExternalUrl").then(function (url) {
                    window.open(url + "/Inscriptions/Index?id=" + uid+"&is_preview=true");
                });
            };

            $scope.addInscriptionFormField = function (inscriptionFormField) {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: InscriptionFormFieldModalView,
                    controller: "InscriptionFormFieldModalCtrl",
                    size: 'lg',
                    resolve: {
                        inscriptionFormField: function () {
                            return inscriptionFormField;
                        },
                        inscriptionForm: function () {
                            return $scope.inscription_form;
                        }
                    }
                });

                $modalInstance.result.then(function (result) {
                    Restangular.all("InscriptionsFormsFields").customPOST(result, "SaveInscriptionField", {}).then(function (response) {
                        toastr.success($filter('translate')('inscriptions_forms.edit_success'));
                        $scope.gridInscriptionsFormsFields.loadData(true);
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            };

            $scope.deleteInscriptionFormField = function (inscriptionFormField) {

                let modalTitle = $filter('translate')('inscriptions_forms.delete_field_title');

                modalService.confirm({
                    title: modalTitle,
                    message: $filter('translate')('inscriptions_forms.delete_field_message'),
                    onAccept: function () {

                        Restangular.all('InscriptionsFormsFields').customDELETE('DeleteInscriptionField', { id: inscriptionFormField.id }).then(function (results) {
                            toastr.success($filter('translate')('inscriptions_forms.delete_field_success'));
                            $scope.gridInscriptionsFormsFields.loadData(true);
                        });

                    }
                });
               
            };

            $scope.addFile = function (flowFile) {

                let fileReader = new FileReader();

                fileReader.onload = function (event) {
                    let uri = event.target.result;
                    $scope.$apply(function () {
                        $scope.inscription_form.icon = uri;
                        if (!$rootScope.isDefinedAndNotNull($scope.inscription_form.FK_inscriptions_forms_images)) {
                            $scope.inscription_form.FK_inscriptions_forms_images = {};
                        }
                        $scope.inscription_form.FK_inscriptions_forms_images.image = uri;
                    });
                };

                fileReader.readAsDataURL(flowFile.file);

            };

            $scope.change = function (emailsToCheck) {

                if (emailsToCheck === "send_email_confirmation") {
                    if (!$scope.inscription_form.send_email_confirmation) {
                        $scope.inscription_form.email_confirmation = "";
                        if (!$scope.$$phase) $scope.$apply();
                    }
                } else if (emailsToCheck === "send_email_enrolled") {
                    if (!$scope.inscription_form.send_email_enrolled) $scope.inscription_form.email_enrolled = ""; if (!$scope.$$phase) $scope.$apply();
                } else {
                    if (!$scope.inscription_form.send_email_rejected) $scope.inscription_form.email_rejected = ""; if (!$scope.$$phase) $scope.$apply();
                }

            };

            let getInscriptionFieldSize = function (field) {

                if (field.class == "col-lg-1 col-md-1 col-sm-1 col-xs-12") {
                    return "1/12";
                } else if (field.class == "col-lg-2 col-md-2 col-sm-2 col-xs-12") {
                    return "2/12";
                } else if (field.class == "col-lg-3 col-md-3 col-sm-3 col-xs-12") {
                    return "3/12";
                } else if (field.class == "col-lg-4 col-md-4 col-sm-4 col-xs-12") {
                    return  "4/12";
                } else if (field.class == "col-lg-5 col-md-5 col-sm-5 col-xs-12") {
                    return  "5/12";
                } else if (field.class == "col-lg-6 col-md-6 col-sm-6 col-xs-12") {
                    return  "6/12";
                } else if (field.class == "col-lg-7 col-md-7 col-sm-7 col-xs-12") {
                    return "7/12";
                } else if (field.class == "col-lg-8 col-md-8 col-sm-8 col-xs-12") {
                    return "8/12"; 
                } else if (field.class == "col-lg-9 col-md-9 col-sm-9 col-xs-12") {
                    return "9/12";
                } else if (field.class == "col-lg-10 col-md-10 col-sm-10 col-xs-12") {
                    return "10/12";
                } else if (field.class == "col-lg-11 col-md-11 col-sm-11 col-xs-12") {
                    return "11/12";
                } else {
                    return "12/12";
                }

            } 

            $scope.enforceTinyMCETextLimit = function (fieldName) {

                let maxLength = 250;

                if ($scope.inscription_form[fieldName]) {
                    var plainText = $scope.inscription_form[fieldName].replace(/<[^>]+>/g, '');
                    if (plainText.length > maxLength) {
                        $scope.inscription_form[fieldName] = plainText.substring(0, maxLength);
                    }
                }

            };

        }])

    .controller("InscriptionFormFieldModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'inscriptionFormField', 'inscriptionForm', 'logService', '$translate',
        function ($scope, $uibModalInstance, Restangular, modalService, $filter, inscriptionFormField, inscriptionForm, logService, $translate) {

            $scope.inscriptionFormFieldModal = (!angular.isUndefined(inscriptionFormField) ? angular.copy(inscriptionFormField) : {});
            $scope.inscriptionFormFieldOrigin = (!angular.isUndefined(inscriptionFormField) ? inscriptionFormField : {});

            Restangular.all('InscriptionsFormsFields').getList({ inscription_form_id: inscriptionForm.id }).then(function(resultFields) {

                $scope.validParentFields = resultFields.filter(m => (m.FK_inscriptions_forms_fields_options_inscriptions_forms_fields != null && m.FK_inscriptions_forms_fields_options_inscriptions_forms_fields.length > 0));
                if (inscriptionFormField != null && inscriptionFormField.parent_field_id != null) {
                    $scope.parentField = resultFields.filter(m => m.id == inscriptionFormField.parent_field_id).pop();
                    $scope.validOptions = $scope.parentField.FK_inscriptions_forms_fields_options_inscriptions_forms_fields;
                }

            });

            $scope.showOptions = false;

            // Se requiere para el tinymce
            let font_size = (window as any).CONFIG_TINYMCE["no_company_id"].font_size;
            let font_family = (window as any).CONFIG_TINYMCE["no_company_id"].font_family;

            $scope.tinymceTitleOptions = {

                resize: true,
                contextmenu: false,
                branding: false,
                schema: "html5",
                relative_urls: false,
                remove_script_host: true,
                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
                },
                invalid_elements: 'strong,em',
                fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px",
                font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
                body_class: 'custom_tinymce_content',
                forced_root_block: false,
                language: $translate.use().toLowerCase(),
                // Hay que customizarlo dependiendo del idioma...
                // language_url: "Scripts/tinymce/langs/es.js",
                plugins: 'textcolor paste',
                toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor fontselect | alignleft aligncenter alignright alignjustify",
                menubar: false,
                forced_root_block_attrs: {
                    'style': 'font-family: ' + font_family + '; font-size: ' + font_size
                },

                setup: function (editor) {
                    editor.on('init', function () {
                        editor.execCommand('FontSize', false, '14px');
                    });
                }

            };   

            logService.debug('inscriptionFormFieldModal')
            logService.debug($scope.inscriptionFormFieldModal);

            if (angular.isDefined($scope.inscriptionFormFieldModal.FK_inscriptions_forms_fields_types_fields) && $scope.inscriptionFormFieldModal.FK_inscriptions_forms_fields_types_fields.has_options) $scope.showOptions = true;

            // Para campos condicionales
            $scope.selectParentField = function (item) {

                $scope.parentField = item;

                if (!item) {

                    $scope.inscriptionFormFieldModal.parent_option_id = null;   

                } else {

                    $scope.validOptions = item.FK_inscriptions_forms_fields_options_inscriptions_forms_fields; 
                    let validOptionsIds = $scope.validOptions.map(m => m.id);

                    if ($scope.validOptions.map(m => m.id).includes($scope.inscriptionFormFieldModal.parent_option_id) == false) {

                        $scope.inscriptionFormFieldModal.parent_option_id = null;

                    }
                }
            } 

            if ($scope.inscriptionFormFieldModal.parent_option_id) {

                $scope.parentField = inscriptionForm.FK_inscriptions_forms_fields_inscriptions_forms.filter(m => m.id == $scope.inscriptionFormFieldModal.parent_option_id).pop();
                $scope.inscriptionFormFieldModal.is_conditional_field = true;

            } else {

                $scope.parentField = null;
                $scope.inscriptionFormFieldModal.is_conditional_field = false;

            }

            Restangular.all("TypesFields").getList().then(function (results) {
                $scope.selectTypesFields = results;
            });

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.saveInscriptionFormField = function () {

                if (!$scope.inscriptionFormFieldModal.is_conditional_field) {
                    $scope.inscriptionFormFieldModal.parent_field_id = null;
                    $scope.inscriptionFormFieldModal.parent_option_id = null;
                }

                $scope.inscriptionFormFieldModal.inscription_form_id = inscriptionForm.id;

                // Devolvemos el control al principal       
                for(let i = 0; i < $scope.selectTypesFields.length; i++) {
                    if ($scope.selectTypesFields[i].id == $scope.inscriptionFormFieldModal.type_field_id) {
                        $scope.inscriptionFormFieldModal.type_field = $scope.selectTypesFields[i];
                        break;
                    }
                }
        
                $uibModalInstance.close($scope.inscriptionFormFieldModal);

            };

            $scope.selectTypeField = function () {
                for (let i = 0; i < $scope.selectTypesFields.length; i++) {
                    if ($scope.selectTypesFields[i].id == $scope.inscriptionFormFieldModal.type_field_id) {
                        if ($scope.selectTypesFields[i].has_options) {
                            $scope.showOptions = true;
                        } else {
                            $scope.showOptions = false;
                        }
                        break;
                    }
                }
            };

            $scope.addNewOption = function () {
                if (typeof ($scope.inscriptionFormFieldModal.FK_inscriptions_forms_fields_options_inscriptions_forms_fields) === "undefined") $scope.inscriptionFormFieldModal.FK_inscriptions_forms_fields_options_inscriptions_forms_fields = [];
                $scope.inscriptionFormFieldModal.FK_inscriptions_forms_fields_options_inscriptions_forms_fields.push({
                    inscription_form_field_id: $scope.inscriptionFormFieldModal.id
                });
            };

            $scope.removeOption = function (index) {
                $scope.inscriptionFormFieldModal.FK_inscriptions_forms_fields_options_inscriptions_forms_fields.splice(index, 1);
            };

}]);